import React from "react";
import "./styles.scss";
import CustomLoader from "../CustomLoader";

const CustomSplash = () => {
  return (
    <div className="custom-splash-container">
      <CustomLoader
        visible={true}
      />
    </div>
  );
};

export default CustomSplash;
